import { INotificationService } from 'fitbeat.notification-service';
import { ITimeSlot } from '../../logic/gymscheduling/igymscheduling';
import { UserProfile } from '../user';
import { Notification, NotificationEntry } from './notification';

export class WaitlistEntry {
  public static GenerateUID(timeSlot: ITimeSlot, userProfileId: string, gymName: string): string {
    return `${userProfileId}${timeSlot.startTime}${timeSlot.endTime}${timeSlot.isDoubleSlotForPartner ? 1 : 0}`
            + `${gymName}`;
  }

  public uid: string;

  // Can elaborate on the states of notifications when we integrate Hendri's notification stuff
  public notifications: NotificationEntry[] = [];

  constructor(
    public timeSlot: ITimeSlot,
    public userProfile: UserProfile,
    public gymName: string,
  ) {
    this.uid = WaitlistEntry.GenerateUID(timeSlot, userProfile.uid, gymName);
  }

  public async notifyOfOpenSlot(
    dateOfRequest: Date = new Date(),
    gymTimezone: string,
    notificationService?: INotificationService,
  ): Promise<boolean> {
    return this.sendNotification(Notification.SlotOpen, dateOfRequest, gymTimezone, notificationService);
  }

  public async notifyThatAllSlotsHaveBeenTaken(
    dateOfRequest: Date = new Date(),
    gymTimezone: string,
    notificationService?: INotificationService,
  ): Promise<boolean> {
    return this.sendNotification(Notification.NoOpenSlot, dateOfRequest, gymTimezone, notificationService);
  }

  private async sendNotification(
    type: Notification,
    dateOfRequest: Date = new Date(),
    timezone: string,
    notificationService?: INotificationService,
  ): Promise<boolean> {
    // Notifcation logic to go here
    if (!this.notifications[this.notifications.length - 1]
            || this.notifications[this.notifications.length - 1].type !== type) {
      // do not renotify
      this.notifications.push(new NotificationEntry(type, dateOfRequest));
      if (notificationService) {
        switch (type) {
          case Notification.SlotOpen:
            notificationService.waitlistOpened({
              recipientUserId: this.userProfile.uid,
              date: new Date(this.timeSlot.startTime),
              timezone,
            }).catch((err) => {
              throw Error(err);
            });
            break;
          case Notification.NoOpenSlot:
            notificationService.waitlistClosed({
              recipientUserId: this.userProfile.uid,
              date: new Date(this.timeSlot.startTime),
              timezone,
            }).catch((err) => {
              throw Error(err);
            });
            break;
        }
      }
      return true;
    }
    return false;
  }
}
